/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowUpRight: {
  name: 'arrow_up_right';
  data: string;
} = {
  name: 'arrow_up_right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M5.47 17.47a.75.75 0 1 0 1.06 1.06L17.25 7.81v7.94a.75.75 0 0 0 1.5 0V6a.747.747 0 0 0-.75-.75H8.25a.75.75 0 0 0 0 1.5h7.94L5.47 17.47Z" fill="currentColor"/></svg>`
};
